module.exports = __webpack_public_path__ + "static/app_screen_3-75ad0dbd7e6c4c173ef9321c5bb0916e.png";